"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4172],{

/***/ 24627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ useCall; },
  "G": function() { return /* binding */ useCalls; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/providers/chainState/multiChainStates/context.js
var context = __webpack_require__(39183);
// EXTERNAL MODULE: ./node_modules/@ethersproject/abi/lib.esm/interface.js
var lib_esm_interface = __webpack_require__(8198);
;// CONCATENATED MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useRawCalls.js



/**
 * A low-level function that makes multiple calls to specific methods of specific contracts and returns values or error if present.
 * The hook will cause the component to refresh when values change.
 *
 * Calls will be combined into a single multicall across all uses of {@link useChainCall}, {@link useChainCalls}, {@link useRawCall} and {@link useRawCalls}.
 * It is recommended to use {@link useCalls} where applicable instead of this method.
 * @public
 * @param calls List of calls, also see {@link RawCall}. Calls need to be in the same order across component renders.
 * @returns list of multicall calls. See {@link RawCallResult} and {@link useRawCall}.
 */
function useRawCalls(calls) {
    const { dispatchCalls, chains } = (0,react.useContext)(context/* MultiChainStatesContext */.J);
    (0,react.useEffect)(() => {
        const filteredCalls = calls.filter(Boolean);
        dispatchCalls({ type: 'ADD_CALLS', calls: filteredCalls });
        return () => dispatchCalls({ type: 'REMOVE_CALLS', calls: filteredCalls });
    }, [JSON.stringify(calls), dispatchCalls]);
    return (0,react.useMemo)(() => calls.map((call) => {
        return call ? extractCallResult(chains, call) : undefined;
    }), [JSON.stringify(calls), chains]);
}
/**
 * A low-level function that makes a call to a specific method of a specific contract and returns the value or error if present.
 * The hook will cause the component to refresh whenever a new block is mined and the value is changed.
 *
 * Calls will be combined into a single multicall across all uses of {@link useChainCall}, {@link useChainCalls}, {@link useRawCall} and {@link useRawCalls}.
 * It is recommended to use {@link useCall} where applicable instead of this method.
 *
 * @param call a single call, also see {@link RawCall}.
 *             A call can be Falsy, as it is important to keep the same ordering of hooks even if in a given render cycle
 *             and there might be not enough information to perform a call.
 * @public
 * @returns result of multicall call.
 *   The hook returns {@link RawCallResult} type.
 *   That is: `undefined` when call didn't return yet or object `{ success: boolean, value: string }` if it did,
 *   `success` - boolean indicating whether call was successful or not,
 *   `value` - encoded result when success is `true` or encoded error message when success is `false`.
 */
function useRawCall(call) {
    return useRawCalls([call])[0];
}
function extractCallResult(chains, call) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const chainId = call.chainId;
    if (chainId !== undefined) {
        const rawCallResult = (_d = (_c = (_b = (_a = chains[chainId]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.state) === null || _c === void 0 ? void 0 : _c[call.address.toLowerCase()]) === null || _d === void 0 ? void 0 : _d[call.data];
        if (rawCallResult) {
            return rawCallResult;
        }
        const error = (_f = (_e = chains[chainId]) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.error;
        if (error) {
            const defaultErrorMessage = 'An error occurred';
            const errorMessage = (_q = (_p = (_m = (_l = (_j = (_h = (_g = error.error) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.message) !== null && _j !== void 0 ? _j : (_k = error.error) === null || _k === void 0 ? void 0 : _k.message) !== null && _l !== void 0 ? _l : error.reason) !== null && _m !== void 0 ? _m : (_o = error.data) === null || _o === void 0 ? void 0 : _o.message) !== null && _p !== void 0 ? _p : error.message) !== null && _q !== void 0 ? _q : defaultErrorMessage;
            const value = new lib_esm_interface/* Interface */.vU(['function Error(string)']).encodeFunctionData('Error', [errorMessage]);
            return {
                success: false,
                value,
            };
        }
    }
}
//# sourceMappingURL=useRawCalls.js.map
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/helpers/calls.js
var helpers_calls = __webpack_require__(96997);
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useChainId.js
var useChainId = __webpack_require__(93942);
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useConfig.js
var useConfig = __webpack_require__(75405);
;// CONCATENATED MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useCall.js





/**
 * Makes a call to a specific method of a specific contract and returns the value or an error if present.
 * The hook will cause the component to refresh when a new block is mined and the return value changes.
 * A syntax sugar for {@link useRawCall} that uses ABI, function name, and arguments instead of raw data.
 * If typechain contract is used in `call` parameter then method name and arguments will be type checked.
 * Result will be typed as well.
 *
 * More on type checking [here](https://usedapp-docs.netlify.app/docs/Guides/Reading/Typechain).
 *
 * @public
 * @param call a single call to a contract, also see {@link Call}
 * @returns The hook returns {@link CallResult} type.
 *
 * @example
 * function useTotalSupply(tokenAddress: string | undefined): BigNumber | undefined {
 *    const { value, error } = useCall(tokenAddress && {
 *      contract: new Contract(tokenAddress, ERC20Interface),
 *      method: 'totalSupply',
 *      args: []
 *    }) ?? {}
 *    if(error) {
 *      console.error(error.message)
 *      return undefined
 *    }
 *    return value?.[0]
 * }
 */
function useCall(call, queryParams = {}) {
    return useCalls([call], queryParams)[0];
}
/**
 * Makes calls to specific methods of specific contracts and returns values or an error if present.
 * The hook will cause the component to refresh when a new block is mined and the return values change.
 * A syntax sugar for {@link useRawCalls} that uses ABI, function name, and arguments instead of raw data.
 * @public
 * @param calls a list of contract calls, also see {@link Call}.
 * @param queryParams see {@link QueryParams}.
 * @returns a list of results (see {@link CallResult}).
 *
 * @example
 * function useTotalSupplies(tokenAddresses: string[] | undefined): (BigNumber | undefined)[] {
 *   const calls = tokenAddresses?.map(address => ({
 *     contract: new Contract(address, ERC20Interface),
 *     method: 'totalSupply',
 *     args: []
 *   })) ?? []
 *   const results = useCalls(calls) ?? []
 *   results.forEach((result, idx) => {
 *     if(result && result.error) {
 *       console.error(`Error encountered calling 'totalSupply' on ${calls[idx]?.contract.address}: ${result.error.message}`)
 *     }
 *   })
 *   return results.map(result => result?.value?.[0])
 * }
 */
function useCalls(calls, queryParams = {}) {
    const chainId = (0,useChainId/* useChainId */.x)({ queryParams });
    const { refresh } = (0,useConfig/* useConfig */.Z)();
    const potentialRawCalls = (0,react.useMemo)(() => calls.map((call) => {
        var _a;
        return chainId !== undefined
            ? (0,helpers_calls/* encodeCallData */.Mo)(call, chainId, Object.assign(Object.assign({}, queryParams), { refresh: (_a = queryParams.refresh) !== null && _a !== void 0 ? _a : refresh }))
            : undefined;
    }), [
        JSON.stringify(calls.map((call) => call && { address: call.contract.address.toLowerCase(), method: call.method, args: call.args })),
        chainId,
    ]);
    const rawCalls = (0,react.useMemo)(() => potentialRawCalls.map((potentialCall) => (potentialCall instanceof Error ? undefined : potentialCall)), [potentialRawCalls]);
    const results = useRawCalls(rawCalls);
    return (0,react.useMemo)(() => results.map((result, idx) => {
        if (potentialRawCalls[idx] instanceof Error) {
            return { value: undefined, error: potentialRawCalls[idx] };
        }
        return (0,helpers_calls/* decodeCallResult */.tX)(calls[idx], result);
    }), [results]);
}
//# sourceMappingURL=useCall.js.map

/***/ }),

/***/ 10391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ useContractFunction; }
});

// UNUSED EXPORTS: connectContractToSigner

// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useConfig.js
var useConfig = __webpack_require__(75405);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useEthers.js
var useEthers = __webpack_require__(57495);
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/providers/transactions/context.js
var context = __webpack_require__(8102);
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/providers/notifications/context.js
var notifications_context = __webpack_require__(3453);
// EXTERNAL MODULE: ./node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(1581);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/addresses.js
var addresses = __webpack_require__(9279);
// EXTERNAL MODULE: ./node_modules/@ethersproject/hash/lib.esm/typed-data.js
var typed_data = __webpack_require__(67827);
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/helpers/chain.js
var chain = __webpack_require__(83778);
;// CONCATENATED MODULE: ./node_modules/@usedapp/core/dist/esm/src/helpers/gnosisSafeUtils.js


const GNOSIS_SAFE_ABI = [
    'function nonce() view returns (uint256)',
    'event ExecutionSuccess(bytes32 txHash, uint256 payment)',
];
const buildSafeTransaction = (template) => {
    return {
        to: template.to,
        value: template.value || 0,
        data: template.data || '0x',
        operation: template.operation || 0,
        safeTxGas: template.safeTxGas || 0,
        baseGas: template.baseGas || 0,
        gasPrice: template.gasPrice || 0,
        gasToken: template.gasToken || addresses/* AddressZero */.d,
        refundReceiver: template.refundReceiver || addresses/* AddressZero */.d,
        nonce: template.nonce || 0,
    };
};
const EIP712_SAFE_TX_TYPE = {
    SafeTx: [
        { type: 'address', name: 'to' },
        { type: 'uint256', name: 'value' },
        { type: 'bytes', name: 'data' },
        { type: 'uint8', name: 'operation' },
        { type: 'uint256', name: 'safeTxGas' },
        { type: 'uint256', name: 'baseGas' },
        { type: 'uint256', name: 'gasPrice' },
        { type: 'address', name: 'gasToken' },
        { type: 'address', name: 'refundReceiver' },
        { type: 'uint256', name: 'nonce' },
    ],
};
const sanitizeTransactionRequest = (transactionRequest) => {
    var _a;
    return Object.assign(Object.assign({}, transactionRequest), { data: (_a = transactionRequest.data) !== null && _a !== void 0 ? _a : '0x' });
};
const calculateSafeTransactionHash = (safe, safeTx, chainId) => {
    return typed_data/* TypedDataEncoder.hash */.E.hash({ verifyingContract: safe.address, chainId }, EIP712_SAFE_TX_TYPE, safeTx);
};
const getLatestNonce = async (chainId, safeAddress) => {
    var _a, _b, _c;
    try {
        const response = await fetch(`https://safe-transaction.${(_a = (0,chain/* getChainById */.xz)(chainId)) === null || _a === void 0 ? void 0 : _a.chainName}.gnosis.io/api/v1/safes/${safeAddress}/all-transactions?limit=1&executed=false&queued=true`);
        if (!response.ok)
            return null;
        const allTransactions = await response.json();
        const latestNonce = (_c = (_b = allTransactions === null || allTransactions === void 0 ? void 0 : allTransactions.results) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.nonce;
        if (!latestNonce)
            return null;
        return latestNonce;
    }
    catch (err) {
        console.error(err);
        return undefined;
    }
};
const waitForSafeTransaction = async (transactionPromise, contract, chainId, safeTx) => {
    const safeTxHash = calculateSafeTransactionHash(contract, safeTx, chainId);
    return new Promise((resolve, reject) => {
        void transactionPromise.catch((err) => {
            if ((err === null || err === void 0 ? void 0 : err.message) === 'Transaction was rejected') {
                reject(err);
            }
        });
        const onExecutionSuccess = async (txHash, _payment, event) => {
            if (txHash === safeTxHash) {
                contract.removeListener('ExecutionSuccess', onExecutionSuccess);
                const transaction = await event.getTransaction();
                const receipt = await event.getTransactionReceipt();
                resolve({ transaction, receipt, rejected: false });
            }
            else {
                const currentNonce = await contract.nonce();
                if (Number(currentNonce) > Number(safeTx.nonce)) {
                    contract.removeListener('ExecutionSuccess', onExecutionSuccess);
                    const transaction = await event.getTransaction();
                    const receipt = await event.getTransactionReceipt();
                    resolve({
                        transaction,
                        receipt,
                        rejected: true,
                    });
                }
            }
        };
        contract.on('ExecutionSuccess', onExecutionSuccess);
    });
};
//# sourceMappingURL=gnosisSafeUtils.js.map
// EXTERNAL MODULE: ./node_modules/@ethersproject/contracts/lib.esm/index.js + 1 modules
var contracts_lib_esm = __webpack_require__(64146);
;// CONCATENATED MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useGnosisSafeContract.js



/**
 * @internal Intended for internal use - use it on your own risk
 */
const useGnosisSafeContract = (account, provider) => {
    const safeContract = (0,react.useRef)(undefined);
    (0,react.useEffect)(() => {
        return () => {
            var _a;
            (_a = safeContract.current) === null || _a === void 0 ? void 0 : _a.removeAllListeners();
        };
    }, []);
    return {
        get: () => {
            if (!account || !provider) {
                return undefined;
            }
            if (safeContract.current) {
                safeContract.current.removeAllListeners();
            }
            safeContract.current = new contracts_lib_esm.Contract(account, GNOSIS_SAFE_ABI, provider);
            return safeContract.current;
        },
    };
};
//# sourceMappingURL=useGnosisSafeContract.js.map
;// CONCATENATED MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/usePromiseTransaction.js







/**
 * @internal
 */
async function estimateTransactionGasLimit(transactionRequest, signer, gasLimitBufferPercentage) {
    if (!signer || !transactionRequest) {
        return undefined;
    }
    try {
        const estimatedGas = transactionRequest.gasLimit
            ? BigNumber.from(transactionRequest.gasLimit)
            : await signer.estimateGas(transactionRequest);
        return estimatedGas === null || estimatedGas === void 0 ? void 0 : estimatedGas.mul(gasLimitBufferPercentage + 100).div(100);
    }
    catch (err) {
        console.error(err);
        return undefined;
    }
}
/**
 * @internal
 */
async function estimateContractFunctionGasLimit(contractWithSigner, functionName, args, gasLimitBufferPercentage) {
    try {
        const estimatedGas = await contractWithSigner.estimateGas[functionName](...args);
        const gasLimit = estimatedGas === null || estimatedGas === void 0 ? void 0 : estimatedGas.mul(gasLimitBufferPercentage + 100).div(100);
        return gasLimit;
    }
    catch (err) {
        console.error(err);
        return undefined;
    }
}
/**
 * @internal
 */
async function isNonContractWallet(library, address) {
    if (!library || !address) {
        return true;
    }
    const code = await library.getCode(address);
    return code === '0x';
}
const isDroppedAndReplaced = (e) => (e === null || e === void 0 ? void 0 : e.code) === lib_esm.ErrorCode.TRANSACTION_REPLACED && (e === null || e === void 0 ? void 0 : e.replacement) && ((e === null || e === void 0 ? void 0 : e.reason) === 'repriced' || (e === null || e === void 0 ? void 0 : e.cancelled) === false);
function usePromiseTransaction(chainId, options) {
    const [state, setState] = (0,react.useState)({ status: 'None', transactionName: options === null || options === void 0 ? void 0 : options.transactionName });
    const { addTransaction, updateTransaction } = (0,context/* useTransactionsContext */.W)();
    const { addNotification } = (0,notifications_context/* useNotificationsContext */.l)();
    const { library, account } = (0,useEthers/* useEthers */.K)();
    const gnosisSafe = useGnosisSafeContract(account, library);
    const resetState = (0,react.useCallback)(() => {
        setState(({ transactionName }) => ({ status: 'None', transactionName }));
    }, [setState]);
    const promiseTransaction = (0,react.useCallback)(async (transactionPromise, { safeTransaction } = {}, transactionRequest) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        const handleNonContractWallet = async (transaction) => {
            if (!chainId)
                return;
            setState(({ transactionName }) => ({ transactionName, transaction, status: 'Mining' }));
            addTransaction({
                transaction: Object.assign(Object.assign({}, transaction), { chainId }),
                submittedAt: Date.now(),
                transactionName: options === null || options === void 0 ? void 0 : options.transactionName,
            });
            const receipt = await transaction.wait();
            updateTransaction({
                transaction: Object.assign(Object.assign({}, transaction), { chainId: chainId }),
                receipt,
                transactionName: options === null || options === void 0 ? void 0 : options.transactionName,
            });
            setState({
                receipt,
                transaction,
                status: 'Success',
                chainId,
                transactionName: options === null || options === void 0 ? void 0 : options.transactionName,
            });
            return { transaction, receipt };
        };
        const handleContractWallet = async (transactionPromise, { safeTransaction } = {}) => {
            var _a;
            if (!chainId || !library || !account)
                return;
            setState({ status: 'CollectingSignaturePool', chainId, transactionName: options === null || options === void 0 ? void 0 : options.transactionName });
            const gnosisSafeContract = gnosisSafe.get();
            if (!gnosisSafeContract) {
                throw new Error("Couldn't create Gnosis Safe contract instance");
            }
            const latestNonce = await getLatestNonce(chainId, account);
            const safeTx = buildSafeTransaction({
                to: (_a = safeTransaction === null || safeTransaction === void 0 ? void 0 : safeTransaction.to) !== null && _a !== void 0 ? _a : '',
                value: safeTransaction === null || safeTransaction === void 0 ? void 0 : safeTransaction.value,
                data: safeTransaction === null || safeTransaction === void 0 ? void 0 : safeTransaction.data,
                safeTxGas: safeTransaction === null || safeTransaction === void 0 ? void 0 : safeTransaction.safeTxGas,
                nonce: latestNonce ? latestNonce + 1 : await gnosisSafeContract.nonce(),
            });
            const { transaction, receipt, rejected } = await waitForSafeTransaction(transactionPromise, gnosisSafeContract, chainId, safeTx);
            if (rejected) {
                const errorMessage = 'On-chain rejection created';
                addTransaction({
                    transaction: Object.assign(Object.assign({}, transaction), { chainId: chainId }),
                    receipt,
                    submittedAt: Date.now(),
                    transactionName: options === null || options === void 0 ? void 0 : options.transactionName,
                });
                setState({
                    status: 'Fail',
                    transaction,
                    receipt,
                    errorMessage,
                    chainId,
                    transactionName: options === null || options === void 0 ? void 0 : options.transactionName,
                });
            }
            else {
                addTransaction({
                    transaction: Object.assign(Object.assign({}, transaction), { chainId: chainId }),
                    receipt,
                    submittedAt: Date.now(),
                    transactionName: options === null || options === void 0 ? void 0 : options.transactionName,
                });
                setState({
                    receipt,
                    transaction,
                    status: 'Success',
                    chainId,
                    transactionName: options === null || options === void 0 ? void 0 : options.transactionName,
                });
            }
            return { transaction, receipt };
        };
        if (!chainId)
            return;
        let transaction = undefined;
        try {
            setState({ status: 'PendingSignature', chainId, transactionName: options === null || options === void 0 ? void 0 : options.transactionName });
            if (options === null || options === void 0 ? void 0 : options.enablePendingSignatureNotification) {
                addNotification({
                    notification: {
                        type: 'transactionPendingSignature',
                        submittedAt: Date.now(),
                        transactionName: options === null || options === void 0 ? void 0 : options.transactionName,
                        transactionRequest,
                    },
                    chainId: chainId,
                });
            }
            const isContractWallet = !(await isNonContractWallet(library, account));
            if (isContractWallet) {
                const result = await handleContractWallet(transactionPromise, { safeTransaction });
                transaction = result === null || result === void 0 ? void 0 : result.transaction;
                return result === null || result === void 0 ? void 0 : result.receipt;
            }
            else {
                transaction = await transactionPromise;
                const result = await handleNonContractWallet(transaction);
                transaction = result === null || result === void 0 ? void 0 : result.transaction;
                return result === null || result === void 0 ? void 0 : result.receipt;
            }
        }
        catch (e) {
            const parsedErrorCode = parseInt((_g = (_e = (_c = (_b = (_a = e.error) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : (_d = e.error) === null || _d === void 0 ? void 0 : _d.code) !== null && _e !== void 0 ? _e : (_f = e.data) === null || _f === void 0 ? void 0 : _f.code) !== null && _g !== void 0 ? _g : e.code);
            const errorCode = isNaN(parsedErrorCode) ? undefined : parsedErrorCode;
            const errorHash = (_l = (_k = (_j = (_h = e === null || e === void 0 ? void 0 : e.error) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.originalError) === null || _k === void 0 ? void 0 : _k.data) !== null && _l !== void 0 ? _l : (_m = e === null || e === void 0 ? void 0 : e.error) === null || _m === void 0 ? void 0 : _m.data;
            const errorMessage = (_v = (_t = (_s = (_q = (_p = (_o = e.error) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.message) !== null && _q !== void 0 ? _q : (_r = e.error) === null || _r === void 0 ? void 0 : _r.message) !== null && _s !== void 0 ? _s : e.reason) !== null && _t !== void 0 ? _t : (_u = e.data) === null || _u === void 0 ? void 0 : _u.message) !== null && _v !== void 0 ? _v : e.message;
            if (transaction) {
                const droppedAndReplaced = isDroppedAndReplaced(e);
                if (droppedAndReplaced) {
                    const status = e.receipt.status === 0 ? 'Fail' : 'Success';
                    const type = status === 'Fail' ? 'transactionFailed' : 'transactionSucceed';
                    addNotification({
                        notification: {
                            type,
                            submittedAt: Date.now(),
                            transaction: e.replacement,
                            receipt: e.receipt,
                            transactionName: (_w = e.replacement) === null || _w === void 0 ? void 0 : _w.transactionName,
                            originalTransaction: transaction,
                        },
                        chainId,
                    });
                    setState((prevState) => {
                        var _a;
                        return (Object.assign(Object.assign({}, prevState), { status, transaction: e.replacement, originalTransaction: transaction, receipt: e.receipt, transactionName: (_a = e.replacement) === null || _a === void 0 ? void 0 : _a.transactionName, errorMessage,
                            errorCode,
                            errorHash,
                            chainId }));
                    });
                }
                else {
                    setState({
                        status: 'Fail',
                        transaction,
                        receipt: e.receipt,
                        errorMessage,
                        errorCode,
                        errorHash,
                        chainId,
                        transactionName: options === null || options === void 0 ? void 0 : options.transactionName,
                    });
                }
            }
            else {
                setState({
                    status: 'Exception',
                    errorMessage,
                    errorCode,
                    errorHash,
                    chainId,
                    transactionName: options === null || options === void 0 ? void 0 : options.transactionName,
                });
            }
            return undefined;
        }
    }, [chainId, addNotification, options === null || options === void 0 ? void 0 : options.transactionName, library, account]);
    return { promiseTransaction, state, resetState };
}
//# sourceMappingURL=usePromiseTransaction.js.map
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/providers/network/readonlyNetworks/context.js
var readonlyNetworks_context = __webpack_require__(10979);
// EXTERNAL MODULE: ./node_modules/@ethersproject/wallet/lib.esm/index.js + 1 modules
var wallet_lib_esm = __webpack_require__(79911);
;// CONCATENATED MODULE: ./node_modules/@usedapp/core/dist/esm/src/helpers/getSignerFromOptions.js

const getSignerFromOptions = (provider, options, library) => {
    const privateKey = options && 'privateKey' in options && options.privateKey;
    const mnemonicPhrase = options && 'mnemonicPhrase' in options && options.mnemonicPhrase;
    const json = options && 'json' in options && options.json;
    const password = options && 'password' in options && options.password;
    const privateKeySigner = privateKey && provider && new wallet_lib_esm.Wallet(privateKey, provider);
    const mnemonicPhraseSigner = mnemonicPhrase && provider && wallet_lib_esm.Wallet.fromMnemonic(mnemonicPhrase).connect(provider);
    const encryptedJsonSigner = json && password && provider && wallet_lib_esm.Wallet.fromEncryptedJsonSync(json, password).connect(provider);
    const optionsSigner = options && 'signer' in options && options.signer;
    return (privateKeySigner ||
        mnemonicPhraseSigner ||
        encryptedJsonSigner ||
        optionsSigner ||
        (library && 'getSigner' in library ? library.getSigner() : undefined));
};
//# sourceMappingURL=getSignerFromOptions.js.map
;// CONCATENATED MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useContractFunction.js






/**
 * @internal Intended for internal use - use it on your own risk
 */
function connectContractToSigner(contract, options, librarySigner) {
    if (contract.signer) {
        return contract;
    }
    if (options && 'signer' in options) {
        return contract.connect(options.signer);
    }
    if (librarySigner) {
        return contract.connect(librarySigner);
    }
    throw new TypeError('No signer available in contract, options or library');
}
/**
 * Hook returns an object with four variables: ``state`` , ``send``, ``events`` , and ``resetState``.
 *
 * The `state` represents the status of transaction. See {@link TransactionStatus}.
 *
 * `resetState` can be used to reset the state to `None` after a transaction attempt has either succeeded or failed.
 *
 * The `events` is a array of parsed transaction events of type [LogDescription](https://docs.ethers.io/v5/api/utils/abi/interface/#LogDescription).
 *
 * To send a transaction use `send` function returned by `useContractFunction`.
 * The function forwards arguments to ethers.js contract object, so that arguments map 1 to 1 with Solidity function arguments.
 * Additionally, there can be one extra argument - [TransactionOverrides](https://docs.ethers.io/v5/api/contract/contract/#contract-functionsSend), which can be used to manipulate transaction parameters like gasPrice, nonce, etc
 *
 * If typechain contract is supplied as contract parameter then function name and send arguments will be type checked.
 * More on type checking [here](https://usedapp-docs.netlify.app/docs/Guides/Reading/Typechain).
 * @public
 * @param contract contract which function is to be called , also see [Contract](https://docs.ethers.io/v5/api/contract/contract/)
 * @param functionName name of function to call
 * @param options additional options of type {@link TransactionOptions}
 * @returns {} object with variables: `send` , `state` , `events`: `{ send: (...args: any[]) => void, state: TransactionStatus, events: LogDescription[] }`.
 *
 * @example
 * const { state, send } = useContractFunction(contract, 'deposit', { transactionName: 'Wrap' })
 *
 * const depositEther = (etherAmount: string) => {
 *   send({ value: utils.parseEther(etherAmount) })
 * }
 * @example
 * const { state, send } = useContractFunction(contract, 'withdraw', { transactionName: 'Unwrap' })
 *
 * const withdrawEther = (wethAmount: string) => {
 *   send(utils.parseEther(wethAmount))
 * }
 */
function useContractFunction(contract, functionName, options) {
    var _a, _b, _c;
    const { library, chainId } = (0,useEthers/* useEthers */.K)();
    const transactionChainId = (options && 'chainId' in options && (options === null || options === void 0 ? void 0 : options.chainId)) || chainId;
    const { promiseTransaction, state, resetState } = usePromiseTransaction(transactionChainId, options);
    const [events, setEvents] = (0,react.useState)(undefined);
    const config = (0,useConfig/* useConfig */.Z)();
    const gasLimitBufferPercentage = (_c = (_b = (_a = options === null || options === void 0 ? void 0 : options.gasLimitBufferPercentage) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.bufferGasLimitPercentage) !== null && _b !== void 0 ? _b : config === null || config === void 0 ? void 0 : config.gasLimitBufferPercentage) !== null && _c !== void 0 ? _c : 0;
    const providers = (0,readonlyNetworks_context/* useReadonlyNetworks */.Kz)();
    const provider = (transactionChainId && providers[transactionChainId]);
    const send = (0,react.useCallback)(async (...args) => {
        var _a;
        if (contract) {
            const numberOfArgs = contract.interface.getFunction(functionName).inputs.length;
            const hasOpts = args.length > numberOfArgs;
            if (args.length !== numberOfArgs && args.length !== numberOfArgs + 1) {
                throw new Error(`Invalid number of arguments for function "${functionName}".`);
            }
            const signer = getSignerFromOptions(provider, options, library);
            const contractWithSigner = connectContractToSigner(contract, options, signer);
            const opts = hasOpts ? args[args.length - 1] : undefined;
            const gasLimit = typeof opts === 'object' && Object.prototype.hasOwnProperty.call(opts, 'gasLimit')
                ? opts.gasLimit
                : (_a = (await estimateContractFunctionGasLimit(contractWithSigner, functionName, args, gasLimitBufferPercentage))) !== null && _a !== void 0 ? _a : null;
            const modifiedOpts = Object.assign({ gasLimit }, opts);
            const modifiedArgs = hasOpts ? args.slice(0, args.length - 1) : args;
            const receipt = await promiseTransaction(contractWithSigner[functionName](...modifiedArgs, modifiedOpts), {
                safeTransaction: {
                    to: contract.address,
                    value: opts === null || opts === void 0 ? void 0 : opts.value,
                    data: contract.interface.encodeFunctionData(functionName, modifiedArgs),
                    safeTxGas: gasLimit !== null && gasLimit !== void 0 ? gasLimit : undefined,
                },
            });
            if (receipt === null || receipt === void 0 ? void 0 : receipt.logs) {
                const events = receipt.logs.reduce((accumulatedLogs, log) => {
                    try {
                        return log.address.toLowerCase() === contract.address.toLowerCase()
                            ? [...accumulatedLogs, contract.interface.parseLog(log)]
                            : accumulatedLogs;
                    }
                    catch (_err) {
                        return accumulatedLogs;
                    }
                }, []);
                setEvents(events);
            }
            return receipt;
        }
    }, [contract, functionName, options, provider, library, gasLimitBufferPercentage, promiseTransaction]);
    return { send, state, events, resetState };
}
//# sourceMappingURL=useContractFunction.js.map

/***/ })

}]);